import { css } from '@/styled-system/css';

export const overlayStyles = css.raw({
  position: 'fixed',
  inset: 0,
  zIndex: 9999,
  pointerEvents: 'auto',
});

// The spotlight creates the dark overlay with a cutout using box-shadow
// This creates a "hole" effect where the highlighted element shows through
export const spotlightStyles = css.raw({
  position: 'absolute',
  borderRadius: '200',
  // Large box-shadow creates the dark overlay around the spotlight
  // The 9999px spread covers the entire viewport
  boxShadow: '0 0 0 9999px rgba(0, 0, 0, 0.55)',
  pointerEvents: 'none',
  // Smooth transition when spotlight moves between targets
  transition: 'top 300ms ease-out, left 300ms ease-out, width 300ms ease-out, height 300ms ease-out',
});

export const popoverStyles = css.raw({
  background: 'bg.neutral',
  borderRadius: '500',
  padding: '400',
  boxShadow: '0 8px 20px rgba(0, 0, 0, 0.15)',
  display: 'flex',
  flexDirection: 'column',
  gap: '0',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 300px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  minWidth: '300px',
  // oxlint-disable-next-line constellation/no-raw-spacing-values -- `maxWidth: 355px` is past the end of the numeric sizes scale, which stops at `5000` (200px)
  maxWidth: '355px',
  // Smooth transition when popover moves between targets
  transition: 'top 300ms ease-out, left 300ms ease-out, width 300ms ease-out',
});

export const popoverCloseButtonStyles = css.raw({
  display: 'flex',
  justifyContent: 'flex-end',
  marginBottom: '0',
});

export const popoverBodyStyles = css.raw({
  fontSize: 'body',
  lineHeight: '1.5',
  color: 'text.neutral',
});

export const popoverFooterStyles = css.raw({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '200',
  marginTop: '100',
});
